import {
  Utensils,
  ShoppingCart,
  Car,
  Home,
  Gamepad2,
  HeartPulse,
  GraduationCap,
  ShoppingBag,
  Shirt,
  Sparkles,
  Repeat,
  PawPrint,
  MoreHorizontal,
  Banknote,
  Briefcase,
  TrendingUp,
  Receipt,
  Gift,
  PlusCircle,
  Tag,
  type LucideIcon,
} from "lucide-react";

const CATEGORY_ICONS: Record<string, LucideIcon> = {
  utensils: Utensils,
  "shopping-cart": ShoppingCart,
  car: Car,
  home: Home,
  "gamepad-2": Gamepad2,
  "heart-pulse": HeartPulse,
  "graduation-cap": GraduationCap,
  "shopping-bag": ShoppingBag,
  shirt: Shirt,
  sparkles: Sparkles,
  repeat: Repeat,
  "paw-print": PawPrint,
  "more-horizontal": MoreHorizontal,
  banknote: Banknote,
  briefcase: Briefcase,
  "trending-up": TrendingUp,
  receipt: Receipt,
  gift: Gift,
  "plus-circle": PlusCircle,
  tag: Tag,
};

// Categorias custom (criadas pelo usuário) podem no futuro guardar um emoji direto no campo
// icon; categorias padrão sempre guardam um nome de ícone lucide (silhueta monocromática, sem
// cor própria - a cor vem do campo color da categoria). Retorna null quando não é um ícone lucide
// conhecido, e o chamador decide como tratar (ex: renderizar `icon` como emoji).
export function getCategoryIcon(icon: string | null | undefined): LucideIcon | null {
  return (icon && CATEGORY_ICONS[icon]) || null;
}

export const DEFAULT_CATEGORY_EMOJI = "🏷️";
